import { render, staticRenderFns } from "./ButtonSubmit-v2.vue?vue&type=template&id=a693bf06&lang=pug"
import script from "./ButtonSubmit-v2.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports